import React, { useEffect, useState } from "react";
import { Modal, Spinner } from "react-bootstrap";
import Select from "react-select";
import { toast } from "react-toastify";
import { getUserByLocation } from "../../../services/UserService";
import { AssetTransferRequest } from "../../../services/AssetService";
import { useSelector } from "react-redux";

const AssetTransferModal = ({
  open,
  onClose,
  afterSubmit,
  asset
}) => {

  const location = useSelector((state) => state.auth.user.location_id);
  const user = useSelector((state) => state.auth.user);
  const [userOptionsLoading, setUserOptionsLoading] = useState(false);
  const [userOptions, setUserOptions] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    to_employee: "",
    remarks: "",
  });
  const [error, setError] = useState({
    to_employee: "",
  });
  
  const getUsers = () => {
    setUserOptionsLoading(true);
    getUserByLocation(location)
      .then((res) => {
        const users = res?.data?.results || [];
        setUserOptions(users?.filter((u)=>u?.value!==user?.id));
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        setUserOptionsLoading(false);
      });
  };

  useEffect(() => {
    setForm({ ...form, to_employee: selectedUser?.value || "" });
    if (selectedUser?.value) {
      setError({ ...error, to_employee: "" });
    }
  }, [selectedUser]);

  useEffect(() => {
    if (open) {
      getUsers();
    } else {
      handleReset();
    }
  }, [open,user]);

  const handleReset = () => {
    setUserOptions([]);
    setSelectedUser(null);
    setForm({
      to_employee: "",
      remarks: "",
    });
    setError({
      to_employee: "",
    });
  };

  const handleRequestSubmit = () => {
    setLoading(true);
    AssetTransferRequest(asset?.asset, form)
      .then((res) => {
        toast.success("Transfer Request Submitted");
        afterSubmit();
      })
      .catch((err) => {
        console.log("err", err)
        toast.error(err?.response?.data?.error||err?.response?.data?.message||'Try again later');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleInternalSubmit = () => {
    let errorObj = {};
    if (!form?.to_employee) {
      errorObj.to_employee = true;
    }
    setError(errorObj);
    if (Object.keys(errorObj).length === 0) {
      handleRequestSubmit();
    }
  };

  return (
    <Modal show={open} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>Transfer Asset</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row p-2 gy-2">
          <div className="col-12">
            <label className="form-label text-dark">Transfer To</label>
            <Select
              classNamePrefix="select"
              className="react-select"
              placeholder="Select User"
              isLoading={userOptionsLoading}
              options={userOptions}
              value={selectedUser}
              onChange={setSelectedUser}
            />
            {error?.to_employee && (
              <div className="text-danger" style={{ fontSize: "0.8rem" }}>
                Mandatory Field
              </div>
            )}
          </div>
          <div className="col-12">
            <label className="form-label text-dark">Remark</label>
            <textarea
              className="form-control"
              rows="1"
              placeholder="Optional"
              name="remark"
              value={form?.remarks}
              onChange={(e) => {
                setForm({ ...form, remarks: e.target.value || "" });
              }}
            ></textarea>
            <code className="text-light">
              <strong>Note</strong>: This asset stays under your responsibility until the transfer is accepted by the recipient.
            </code>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="d-flex justify-content-end gap-2 w-100">
          <span className="btn btn-outline-danger" onClick={onClose}>
            Cancel
          </span>
          <button
            className="btn btn-primary"
            onClick={handleInternalSubmit}
            disabled={loading}
          >
            {loading && (
              <Spinner
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />
            )}
            Transfer
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default AssetTransferModal;
